import React, { useState, useEffect, useRef, useContext } from "react";
import { Button,  InputText, Toast } from "primereact";
import { Checkbox } from "primereact/checkbox";
import {Dialog} from 'primereact/dialog'

import Loader from "../../../Components/Loader/Loader";
import AutoCompleteDropdown from "../../../Components/Form/AutoCompleteDropdown";
import { toastShow } from "../../../Services/ToastService";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";
import { useForm } from "../../../Hooks/useForm";

import { EditarMetrica, GuardarMetrica } from "../../../../API/IT/Metricas/MetricasRequest";
import { getMenus } from "../../../API/Menu/MenuRequests";

const MetricasCRUD = ({
  showDialog,
  selected,
  setShowDialog,
  getInfo,
  modo,
}) => {
  const toastDialog = useRef(null);
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [menus, setMenus] = useState([]);

  const initialValues = {
    IdMetrica: -1,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);

    const menusTempo = await getMenus()
    setMenus(menusTempo)

    const menuInicial = modo === "Crear" ? null : menusTempo.find((e) => e.IdMenu === selected?.IdMenu);


    setValues({
      ...selected,
      Menu: menuInicial?.Titulo,
      IdMenu: menuInicial?.IdMenu,
    });

    setLoading(false);
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
  };

  const verificarInfo = () => {
    let error = {};

    if (!values.Nombre) {
      error.Nombre = true;
      error.error = true;
    }
    if (values?.IdMetrica > 0) {
      if (!values.Menu) {
        error.IdMenu = true;
        error.error = true;
      }
    } else {
      if (!values.Menu?.IdMenu) {
        error.IdMenu = true;
        error.error = true;
      }
    }

    setError(error);
    return error;
  };

  const agregarMetrica = async () => {
    const e = verificarInfo();
    if (!e?.error) {
      const Datos = {
        IdMetrica: values?.IdMetrica ? values?.IdMetrica : -100,
        Nombre: values?.Nombre,
        Descripcion: values?.Descripcion,
        IdMenu: values?.Menu?.IdMenu || values?.IdMenu,
        Pm2: values?.Pm2,
        IdUserCreate: userAuth?.idUser,
      }
      setLoading(true)


      if (Datos?.IdMetrica > 0) {
        const respuesta = await EditarMetrica(Datos)
        if (respuesta[0].ESTADO !== -1) {
          toastShow(toast, "success", "Editada", respuesta[0].MENSAJE);
          setTimeout(() => {
            onHide();
            setLoading(false);
            getInfo();
          }, 1500);
        } else {
          toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
          setLoading(false);
        }
      } else {
        const respuesta = await GuardarMetrica(Datos)
        if (respuesta[0].ESTADO !== -1) {
          toastShow(toast, "success", "Guardado", respuesta[0].MENSAJE);
          setTimeout(() => {
            onHide();
            setLoading(false);
            getInfo();
          }, 1500);
        } else {
          toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
          setLoading(false);
        }
      }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={"Guardar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarMetrica}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  const dialogTitle = modo === "Crear" ? "Agregar Métrica" : "Editar Métrica";

  return (
    <div>
      <Dialog visible={showDialog} footer={DialogFooter} onHide={onHide} style={{ width: '45vw', height: '28vh' }} modal
        header={<div className="d-flex align-items-center">
          <h2 className="me-3">{dialogTitle}</h2>
        </div>}>
        <Loader loading={loading} querySelector={"#DialogMetricas"} />
        <Toast ref={toast} />
        <div id="DialogMetricas">
          <div style={{ width: "100", margin: "auto" }}>
            <Toast ref={toastDialog}  />
            <div className="modal__input-contenedor2 mt-4">
              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Nombre"
                    value={values.Nombre}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Nombre ? "p-invalid" : ""}
                  />
                  <label htmlFor="Nombre">Nombre de Métrica</label>
                </span>
              </div>

              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Descripcion"
                    value={values.Descripcion}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Descripcion ? "p-invalid" : ""}
                  />
                  <label htmlFor="Descripcion">Descripción</label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor2 mt-2">
              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={'Menu'}
                    habilitar={false}
                    value={values?.Menu}
                    items={menus}
                    field={'Titulo'}
                    handleInputChange={handleInputChange}
                    tabIndex={4}
                    label={'Menu'}
                  />
                </span>
              </div>

              <div className="field col-6 mt-3">
                <span className="p-float-label">
                  <Checkbox
                    checked={values.Pm2}
                    onChange={(e) =>
                      setValues({
                        ...values,
                        Pm2: e.target.checked,
                      })
                    }
                    style={{marginTop: 5}}
                  />
                  <label htmlFor="Pm2" style={{marginTop: -5}}>
                    &nbsp;&nbsp;&nbsp;&nbsp;Pm2
                  </label>
                </span>
              </div>
            </div>
          </div>
        </div>



      </Dialog>
    </div>
  );
};

export default MetricasCRUD;
